(() => {
  const sortProductGrid = (root = document) => {
    root.querySelectorAll('.product-grid').forEach((grid) => {
      const items = [...grid.children];
      const available = items.filter((item) => item.dataset.productAvailable === 'true');
      const other = items.filter((item) => !item.dataset.productAvailable);
      const soldOut = items.filter((item) => item.dataset.productAvailable === 'false');

      if (!soldOut.length) return;
      const desiredOrder = [...available, ...other, ...soldOut];
      if (desiredOrder.every((item, index) => item === items[index])) return;
      desiredOrder.forEach((item) => grid.appendChild(item));
    });
  };

  let scheduled = false;
  const scheduleSort = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      sortProductGrid();
      scheduled = false;
    });
  };

  document.addEventListener('DOMContentLoaded', scheduleSort, { once: true });
  document.addEventListener('shopify:section:load', scheduleSort);

  const observer = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.addedNodes.length)) scheduleSort();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
